import NACell from '../Reusable/DataTable/NACell';
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import TableActionButton from '../Reusable/TableActionButton';
import DataTable from '../Reusable/DataTable/TicketService';
import moment from 'moment';
import Modal from '../Reusable/Modal';
import { useState } from 'react';
import ChangeStatus from './ChangeStatus';

const TicketList = (props: any) => {
  const [openStatusChangePopup, setOpenStatusChangePopup] = useState(false)
  const [selectedId, setSelectedId] = useState<undefined | null | string>(null)
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Vendor",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Subject",
      accessorKey: "queue.name",
      cell: NACell,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: NACell,
    },
    {
      header: "Reply",
      accessorKey: "resolution",
      cell: NACell,
    },
    {
      header: "Priority",
      accessorKey: "priority",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ? moment(getValue()).format('YY-MM-DD HH:mm:ss') : "N/A"}</p>
          </>
        )
      },
    },


    {
      header: "Status",
      accessorKey: "status.name",
      cell: NACell,
    },
  ];
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  if (userProfileType?.is_staff) {
    defaultColumns.push({
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <div onClick={() => {
          setOpenStatusChangePopup(!openStatusChangePopup)
          setSelectedId(getValue())
        }}>
          <TableActionButton />
        </div>
      ),
    },)
  }
  return (
    <>
      <DataTable
        url={APIS.TICKET}
        queryKey={"ticket"}
        columns={defaultColumns}
        addNewPagePath={userProfileType?.is_merchant ? "/create-ticket" : ""}
        tableName={"Ticket"}
        isUpload={false}
      />
      <Modal
        isOpen={openStatusChangePopup}
        setIsOpen={setOpenStatusChangePopup}
        title={"Change Status"}
        children={<>
          <ChangeStatus
            selectedId={selectedId}
            setOpenStatusChangePopup={setOpenStatusChangePopup}
          />
        </>}
      />
    </>


  )
}

export default TicketList
